import EventEmitter from "events";
import type { TValidators, IValidator } from "./Validators"

export default class FormControl<T> extends EventEmitter implements IValidator {
    private _name : string;
    private _validators : TValidators<T>
    private _error : string|null = null
    private _dirty = false
    private _value : T|undefined|null

    constructor(name:string, validators:TValidators<T>, defaultValue?:T) {
        super()
        this._name = name
        this._validators = validators
        this._value = defaultValue
        this._error = this.validate(this._value)
    }

    get name() { return this._name}
    get error() { return this._error }
    get valid(){ return !this._error}
    get dirty() { return this._dirty}

    private _validate(value:T|undefined|null){
        for(let validator of this._validators){
            const result = validator(value)
            if (result) return result
        }
        return null
    }

    setError(error:string|null){
        this._error = error
        return this
    }

    revalidate(){
        this._error = this._validate(this._value)
        this.emit("refresh", this)
        return this
    }
    /**
     * updates value, mark as dirty, and fires refresh
     * @param value 
     */
    update(value:T|undefined|null) {
        this.validate(value)
        this.setDirty(true)
        this.emit("refresh", this)
        return this
    }
    validate(value:T|undefined|null){
        this._value = value
        this._error = this._validate(value)
        return this._error
    }
    setDirty(dirty:boolean, notify:boolean=false){
        this._dirty = dirty
        notify && this.emit("refresh", this)
        return this
    }
}
